import { React, useState, useEffect } from "react";
import Header from "../components/Header";
import { HiSearch } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import AdminSideBar from "../components/AdminSideBar";
import Footer from "../components/Footer";
import { getFirestore, collection, addDoc, getDocs, doc, deleteDoc } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../../firebase";

const editicon = "/editicon.png";
const view = "/View.png";
const trash = "/Trash.png";
const save = "https://res.cloudinary.com/dzngpgki4/image/upload/v1749847424/Add_ring_light_pqdceg.png";

const importing = "/importicon.png";
const stopplayicon = "/stopplayicon.png";
const addicon = "https://res.cloudinary.com/dzngpgki4/image/upload/v1749666377/Import_dck7ww.png";
const levels = ["Level 5", "Level 4", "Level 3", "Level 2", "Level 1"];

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const UserAccount = () => {
  const [selectedLevel, setSelectedLevel] = useState("Level 5");
  const [tableData, setTableData] = useState([]);
  const [isViewMode, setIsViewMode] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isSuspended, setIsSuspended] = useState(false);
  const [headerInputs, setHeaderInputs] = useState({
    name: "",
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    view: false,
    edit: false,
    add: false,
    delete: false,
    suspend: false,
    download: false
  });

  // Load users from Firestore on component mount
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const querySnapshot = await getDocs(collection(db, "adminUsers"));
        const users = [];
        querySnapshot.forEach((doc) => {
          users.push({ id: doc.id, ...doc.data() });
        });
        setTableData(users);
      } catch (err) {
        setError("Failed to load users");
        console.error("Error fetching users:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleView = () => {
    setIsViewMode(!isViewMode);
    setSelectedOptions({
      ...selectedOptions,
      view: !selectedOptions.view
    });
  };

  const handleEdit = () => {
    setIsEditing(!isEditing);
    setSelectedOptions({
      ...selectedOptions,
      edit: !selectedOptions.edit
    });
  };

  const handleAdd = () => {
    const newRow = {
      name: "New User",
      email: "new@farmnet.africa",
      password: "NewPassword123",
      accessLevel: selectedLevel
    };
    setTableData([...tableData, newRow]);
    setSelectedOptions({
      ...selectedOptions,
      add: !selectedOptions.add
    });
  };

  const handleSuspend = (id) => {
    setIsSuspended(!isSuspended);
    setSelectedOptions({
      ...selectedOptions,
      suspend: !selectedOptions.suspend
    });
    // In a real app, you would update this in Firestore
  };

  const handleSave = () => {
    // Placeholder function for saving changes
    console.log("Save functionality triggered");
    setSelectedOptions({
      ...selectedOptions,
      save: !selectedOptions.save
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await deleteDoc(doc(db, "adminUsers", id));
        setTableData(tableData.filter(user => user.id !== id));
        setSelectedOptions({
          ...selectedOptions,
          delete: !selectedOptions.delete
        });
      } catch (err) {
        setError("Failed to delete user");
        console.error("Error deleting user:", err);
      }
    }
  };

  const handleUpdateRow = async (index, field, value) => {
    const newData = [...tableData];
    newData[index] = { ...newData[index], [field]: value };
    setTableData(newData);
    
    // In a real app, you would update Firestore here
  };

  const handleHeaderChange = (field, value) => {
    setHeaderInputs({
      ...headerInputs,
      [field]: value
    });
  };

  const handleAssignRights = async () => {
    if (!headerInputs.name || !headerInputs.email || !headerInputs.password) {
      setError("Please fill in all fields");
      return;
    }
  
    setLoading(true);
    setError(null);
  
    try {
      // Check if user already exists
      const userExists = tableData.some(user => 
        user.email.toLowerCase() === headerInputs.email.toLowerCase()
      );
      
      if (userExists) {
        throw new Error("User with this email already exists");
      }
  
      const newUser = {
        name: headerInputs.name, // Make sure name is included
        email: headerInputs.email,
        password: headerInputs.password,
        accessLevel: selectedLevel,
        createdAt: new Date().toISOString(),
        isActive: true
      };
  
      // Add to Firestore
      const docRef = await addDoc(collection(db, "adminUsers"), newUser);
      
      // Update local state with the new user (including the Firestore ID)
      setTableData([...tableData, { id: docRef.id, ...newUser }]);
      
      // Reset form
      setHeaderInputs({
        name: "", // Reset name field
        email: "",
        password: ""
      });
      
    } catch (err) {
      setError(err.message || "Failed to assign user rights");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#FAFBFB]">
      <Header/>
      <div className="flex flex-col md:min-h-screen">
        <div className="flex flex-grow">
          <div>
            <AdminSideBar />
          </div>
          <div className="flex-grow p-1 sm:p-2 md:p-4 px-2 md:px-6 flex flex-col w-full">
            {/* Header Section */}
            <div className="flex flex-col lg:flex-row lg:justify-between items-center gap-2">
              <h1 className="font-bold text-[14px] sm:text-[16px] md:text-[24px]">USER ACCESS RIGHTS</h1>
              <div className="relative w-full lg:w-auto">
                <input
                  type="text"
                  placeholder="Search"
                  className="md:w-[600px] w-full h-[35px] sm:h-[45px] md:h-[57px] text-[#919291] text-[10px] sm:text-[12px] md:text-[15px] font-medium p-2 sm:p-3 pr-8 sm:pr-10 border-[2px] sm:border-[3px] border-[#D9D9D9] rounded-md focus:outline-none focus:ring-2 focus:ring-green-600"
                />
                <HiSearch
                  className="absolute right-2 sm:right-3 top-1/2 transform -translate-y-1/2 text-black"
                  size={16}
                />
              </div>
            </div>

            {/* Levels Navigation */}
            <div className="flex flex-wrap gap-1 py-2 sm:py-4 w-full">
              {levels.map((level) => (
                <div
                  key={level}
                  className={`text-[10px] sm:text-[11px] md:text-[15px] font-medium h-[40px] sm:h-[50px] md:h-[80px] rounded-md p-1 sm:p-2 md:p-4 flex-grow cursor-pointer transition-all duration-300 ${
                    selectedLevel === level 
                      ? 'bg-[#152C24] text-white' 
                      : 'bg-[#EDF0EF] hover:bg-[#152C24] hover:text-white'
                  }`}
                  onClick={() => setSelectedLevel(level)}
                >
                  <span className="block text-[10px] sm:text-[14px] md:text-[20px] font-bold">{level}</span>
                  <span className="block text-[8px] sm:text-[12px] md:text-[16px] font-normal">Access Rights</span>
                </div>
              ))}
            </div>

            {/* User Access Rights Section */}
            <div className="flex md:flex-row justify-between items-center mt-1 mb-1 sm:mb-2 gap-1 sm:gap-2">
              <h1 className="text-[10px] sm:text-[12px] md:text-[16px] font-bold mb-2">User Access rights</h1>
              <div 
                className="flex items-center gap-1 sm:gap-2 cursor-pointer"
                onClick={handleAdd}
              >
                <span className="text-[10px] sm:text-[12px] md:text-[16px] font-medium text-[#919291]">Add user</span>
                <img src={addicon} alt="Add Icon" className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
              </div>
            </div>

            {/* Error Message */}
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                {error}
              </div>
            )}

            {/* Loading Indicator */}
            {loading && (
              <div className="text-center py-4">
                <span className="animate-spin inline-block w-6 h-6 border-4 border-blue-500 rounded-full border-t-transparent"></span>
                <p>Processing...</p>
              </div>
            )}

            {/* Main Content Area */}
            <div className="flex md:flex-row gap-2 sm:gap-4 w-full">
              {/* Left Sidebar */}
              <div className="w-full md:w-[25%]">
<div className=" p-4 bg-[#EDF0EF] md:h-[15%] rounded-[5px]">
<span className="block text-[10px] sm:text-[14px] md:text-[20px] font-extrabold">{selectedLevel}</span>
<span className="block text-[8px] sm:text-[12px] md:text-[16px] font-medium">Access Rights</span>
</div>
                <div className="bg-[#FFF9F0] h-auto flex flex-col p-1 sm:p-2 md:p-4 gap-2 sm:gap-3 md:gap-8">
                  {[
                    { icon: view, text: "View", handler: handleView, key: "view" },
                    { icon: editicon, text: "Edit", handler: handleEdit, key: "edit" },
                    { icon: addicon, text: "Add", handler: handleAdd, key: "add" },
                    { icon: save, text: "Save", handler: handleSave, key: "Save" },
                    { icon: stopplayicon, text: "Suspend", handler: handleSuspend, key: "suspend" },
                    { icon: importing, text: "Download", handler: () => {}, key: "download" },
                    
                    { icon: trash, text: "Delete", handler: handleDelete, key: "delete" },
                  ].map((item) => (
                    <div key={item.key} className="flex justify-between items-center gap-1 sm:gap-2 cursor-pointer" onClick={item.handler}>
                  
                <div className="flex items-center gap-1 sm:gap-4"> 
                <img src={item.icon} alt={item.text} className="w-[10px] h-[10px] sm:w-[16px] sm:h-[16px] md:w-[25px] md:h-[25px]" />
                <h1 className="text-[8px] sm:text-[12px] md:text-[20px] font-extrabold">{item.text}</h1>
                </div>
                      <div 
                        className={`w-[10px] h-[10px] sm:w-[15px] sm:h-[15px] md:w-[25px] md:h-[25px] rounded-full ${
                          selectedOptions[item.key] ? 'bg-[#152C24]' : 'bg-[#EDF0EF]'
                        }`}
                      />
                    </div>
                    
                  ))}
                </div>
              </div>

              {/* Right Content */}
              <div className="w-full">
                {/* Header Inputs */}
                <div className="grid grid-cols-3 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-2">
                  {['name', 'email', 'password'].map((field) => (
                    <div key={field} className="text-[6px] sm:text-[11px] md:text-[15px] font-medium bg-[#FAFBFB] border border-[#919291] w-full h-[25px] sm:h-[50px] md:h-[75px] rounded-md">
                      <span className="block text-[6px] sm:text-[12px] md:text-[16px] font-bold ml-1 sm:ml-2 capitalize">{field}</span>
                      <input
                        type={field === 'password' && isViewMode ? 'password' : 'text'}
                        value={headerInputs[field]}
                        onChange={(e) => handleHeaderChange(field, e.target.value)}
                        className="block text-[6px] sm:text-[12px] md:text-[16px] md:mt-0 -mt-3 font-normal border-none outline-white border-white bg-transparent w-full px-1 sm:px-2"
                        placeholder={`Enter ${field}`}
                      />
                    </div>
                  ))}
                </div>

                {/* Table Rows */}
                <div className="mt-2 sm:mt-4 space-y-1 sm:space-y-2">
                  {tableData.map((row, index) => (
                    <div 
                      key={row.id || index}
                      className={`grid grid-cols-3 sm:grid-cols-2 lg:grid-cols-3 gap-1 ${
                        isSuspended ? 'opacity-50' : ''
                      }`}
                    >
                      {isEditing ? (
                        ['name', 'email', 'password'].map((field) => (
                          <input
                            key={field}
                            type={field === 'email' ? 'email' : 'text'}
                            value={row[field]}
                            onChange={(e) => handleUpdateRow(index, field, e.target.value)}
                            className="text-[6px] sm:text-[12px] md:text-[16px] font-normal bg-white border border-gray-300 w-full h-[20px] sm:h-[40px] md:h-[60px] rounded-md p-o sm:p-2"
                          />
                        ))
                      ) : (
                        ['name', 'email', 'password'].map((field) => (
                          <div key={field} className="text-[6px] sm:text-[12px] md:text-[16px] font-normal bg-[#EDF0EF] w-full h-[20px] sm:h-[40px] md:h-[60px] rounded-md p-1 sm:p-2 flex items-center">
                            {isViewMode && field !== 'password' ? row[field] : '•'.repeat(row[field]?.length || 0)}
                          </div>
                        ))
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end p-1 md:mt-0 mt-4 sm:p-2 md:p-4">
          <button 
            onClick={handleAssignRights}
            disabled={loading}
            className={`md:w-[270px] w-[120px] sm:w-[150px] md:h-[50px] h-[18px] sm:h-[40px] rounded-[5px] text-white font-bold text-[8px] sm:text-[14px] md:text-[20px] ${
              loading ? 'bg-gray-400' : 'bg-[#152C24] hover:bg-[#0F1F1A]'
            } transition-colors duration-300`}
          >
            {loading ? 'Processing...' : 'Assign User rights'}
          </button>
        </div>
        <div className="mt-auto">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default UserAccount;